export * from './FooterSocial'
export * from './FooterActiveLink'

export * from './for-small-devices'

export { default } from './Footer'
